import {Box, Alert} from "@mui/material";
import AuthPage, { useAuth } from "./Auth/AuthPage.jsx";

const LoginRequired = (props) => {
    const { loggedIn } = useAuth();

    return loggedIn ? props.children :
       <Box>
        <Alert severity={"warning"}>
            You must be logged in to use this feature.
        </Alert>
        <AuthPage />
    </Box>
}




export default LoginRequired